/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAllInclusiveIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-all-inclusive"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.35 17.9Q2.9 17.9 1.18 16.18Q-0.55 14.45 -0.55 11.97Q-0.55 9.53 1.16 7.79Q2.88 6.05 5.35 6.05Q6.35 6.05 7.29 6.38Q8.22 6.7 8.95 7.4L10.47 8.88L8.5 10.65L7.15 9.4Q6.78 9.05 6.31 8.88Q5.85 8.7 5.35 8.7Q4 8.7 3.05 9.66Q2.1 10.63 2.1 12Q2.1 13.35 3.05 14.3Q4 15.25 5.35 15.25Q5.85 15.25 6.31 15.07Q6.78 14.9 7.15 14.55L15.05 7.4Q15.78 6.7 16.71 6.38Q17.65 6.05 18.65 6.05Q21.1 6.05 22.82 7.78Q24.55 9.5 24.55 11.95Q24.55 14.43 22.84 16.16Q21.13 17.9 18.65 17.9Q17.65 17.9 16.71 17.57Q15.78 17.25 15.05 16.55L13.53 15.13L15.53 13.32L16.85 14.55Q17.23 14.9 17.69 15.07Q18.15 15.25 18.65 15.25Q20 15.25 20.95 14.29Q21.9 13.32 21.9 11.95Q21.9 10.6 20.95 9.65Q20 8.7 18.65 8.7Q18.15 8.7 17.69 8.88Q17.23 9.05 16.85 9.4L8.95 16.55Q8.22 17.25 7.29 17.57Q6.35 17.9 5.35 17.9Z" fill={color} />
    </svg>
  );
}
